<div
  class="{{ width }} m-auto font-medium text-end"
  [class.max-w-2xl]="progress">
  <div class="flex justify-between">
    <div class="" [ngClass]="progress ? '' : 'text-end'">
      <div class="flex w-full" [ngClass]="fontsSizePrice">
        <span [class.mt-4]="editable" class="font-light">$</span>
        <div class="ml-4 font-light w-full" *ngIf="!editable">
          {{ price | currency : ' ' : 'symbol' }}
        </div>

        <input
          mask="separator.2"
          thousandSeparator=","
          decimalMarker="."
          class="ml-4 font-medium w-full"
          name=""
          value=""
          [(ngModel)]="price"
          (keyup)="change()"
          treoAutofocus
          onkeypress="return event.charCode >= 48 && event.charCode <= 57 || event.charCode == 46"
          *ngIf="editable" />
      </div>
    </div>
    <div class="text-end" *ngIf="provider">
      <small>{{ provider.company.name }}</small>
      <img
        class="w-10 h-10 ml-auto object-scale-down"
        [src]="provider.company.img"
        alt="" />
    </div>
  </div>

  <mat-progress-bar
    class="price-information"
    [color]="'primary'"
    [mode]="'determinate'"
    [value]="35"
    [bufferValue]="100"
    *ngIf="progress"></mat-progress-bar>

  <div
    class="flex justify-between font-medium mt-3"
    *ngIf="convertToPrice && convertToCurrency">
    <div class="text-start">
      <small>{{ 'shared:currentRate' | translate }}</small>
      <div class="">
        1 ${{ currency }} = {{ convertToPrice / price | currency }} ${{
          convertToCurrency
        }}
      </div>
    </div>

    <div class="text-end">
      <small>{{ 'shared:amountToPay' | translate }}</small>
      <div class="">
        {{ convertToPrice | currency }} {{ convertToCurrency }}
      </div>
    </div>
  </div>
</div>
